/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MeResponseDto
 */
export interface MeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof MeResponseDto
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof MeResponseDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof MeResponseDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof MeResponseDto
     */
    role: MeResponseDtoRoleEnum;
}


/**
 * @export
 */
export const MeResponseDtoRoleEnum = {
    Underwriter: 'Underwriter',
    Finance: 'Finance',
    Claims: 'Claims',
    SuperUser: 'Super User'
} as const;
export type MeResponseDtoRoleEnum = typeof MeResponseDtoRoleEnum[keyof typeof MeResponseDtoRoleEnum];


/**
 * Check if a given object implements the MeResponseDto interface.
 */
export function instanceOfMeResponseDto(value: object): value is MeResponseDto {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function MeResponseDtoFromJSON(json: any): MeResponseDto {
    return MeResponseDtoFromJSONTyped(json, false);
}

export function MeResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'email': json['email'] == null ? undefined : json['email'],
        'name': json['name'] == null ? undefined : json['name'],
        'role': json['role'],
    };
}

export function MeResponseDtoToJSON(json: any): MeResponseDto {
    return MeResponseDtoToJSONTyped(json, false);
}

export function MeResponseDtoToJSONTyped(value?: MeResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'email': value['email'],
        'name': value['name'],
        'role': value['role'],
    };
}

